<span class="value">
    @for (part of parseValue(text); track $index) {
        @switch (part.type) {
            @case ('text') {
                <span> {{ part.text }} </span>
            }
            @case ('libraryResource') {
                <span> <a [href]=part.url target="_blank">{{ part.text }}</a> </span>
            }
            @case ('photoUrn') {
                <span> <a [routerLink]="['/photos', part.photoUrn]">{{ part.text }}</a> </span>
            }
            @case ('guid') {
                <span> <a [routerLink]="['/search']" [queryParams]="{q: part.guid}">{{ part.text }}</a> </span>
            }
        }
    }
</span>
